import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { CourseTema } from "../../const/types";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";

type Props = {
  data: CourseTema;
};

export default function RestoreCourseTemaModal({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();

  const onRestore = () => {
    setLoading(true);
    const url = `api/course/theme/${data.id}/restoretheme`;
    cr.post(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: e.response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        colorScheme="ap"
        variant={"ghost"}
        className="clicky"
        onClick={onOpen}
      >
        Restore
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        initialFocusRef={undefined}
        scrollBehavior="inside"
      >
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton />

          <ModalHeader>Restore Tema Course</ModalHeader>

          <ModalBody>
            <Text>
              Apakah Anda yakin akan mengembalikan data tema course{" "}
              <b>{data.theme_name}</b>
            </Text>
          </ModalBody>

          <ModalFooter gap={2}>
            <Button onClick={onClose} className="btn clicky">
              Batal
            </Button>

            <Button
              colorScheme="p"
              className="clicky"
              isLoading={loading}
              onClick={onRestore}
            >
              Restore
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
